module.exports = __webpack_public_path__ + "img/RDS_Relax.f491f39d.png";